<template>
    <div class="uredaj-obavijest">
        <div class="cnt">
            <img class="logo-milun" src="~@/assets/img/milun.png" />
            <h2>Toni Milun Liga</h2>

            <p class="description">Ligu je moguće igrati samo s jednog uređaja.</p>
            <router-link :to="{ name: 'home'}"><p class="button-1 red no-arrow"><span>Igraj ovdje</span></p></router-link>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
    .uredaj-obavijest {
        .cnt {
            padding: 15px;
            background: white;
            border-radius: 12px;
            max-width: 360px;
            width: calc(100% - 32px);
            margin: 0 auto;
            min-height: 350px;
        }
        .logo-milun {
            margin: 5px;
        }
        p.description {
            font-family: "axiforma";
            font-size: 16px;
            line-height: 18px;
            letter-spacing: .3px;
            color: $font-black-color;
            margin-top: 65px;
            a {
                font-weight: bold;
            color: #54ddff;
            }
        }
    }
</style>
